// extracted by mini-css-extract-plugin
export default {"box":"Error_box__dFSvi"};